<script setup lang="ts">
import { dayjs } from '@revolugo/common/utils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { RDateProps } from './RDate.types.ts'

const { locale } = useI18n()
const props = defineProps<RDateProps>()
const date = computed(() =>
  dayjs(props.date).isValid()
    ? dayjs(props.date)
        .locale(locale.value)
        .format(props.format || 'LL')
    : 'N/A',
)
</script>

<template>
  <div
    class="flex flex-col"
    :class="direction === 'end' ? 'items-end' : 'items-start'"
  >
    <span class="text-gray-500 text-sm"> {{ label }}</span>
    <a
      v-if="link"
      :href="link"
      target="_blank"
      class="body-1-semibold text-primary"
    >
      {{ date }}
    </a>
    <span
      v-else
      class="body-1-semibold"
    >
      {{ date }}
    </span>
    <span
      v-if="time"
      class="text-gray-500"
    >
      {{ time }}
    </span>
  </div>
</template>
